import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import CtaBand from "../components/CtaBand";
import { ARTICLES } from "../data/articles";

const Approfondimenti = () => (
  <>
    <Seo
      title="Approfondimenti su lavoro e previdenza | Avv. Manfredi Bruno"
      description="Guide e approfondimenti dell'Avv. Manfredi Bruno su licenziamento, TFR, ricorsi INPS, pensioni e diritti del lavoratore, in linguaggio chiaro."
      path="/approfondimenti"
    />
    <PageHero
      kicker="Approfondimenti"
      title="Guide e approfondimenti"
      intro="Articoli in linguaggio chiaro su diritto del lavoro, previdenza e rapporti con l'INPS: informazioni utili per comprendere i tuoi diritti, scritte per chi non è del mestiere."
      breadcrumb="Approfondimenti"
    />

    <section className="bg-white py-14 sm:py-20">
      <div className="container-site grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-testid="articles-grid">
        {ARTICLES.map((a) => (
          <Link
            key={a.slug}
            to={`/approfondimenti/${a.slug}`}
            data-testid={`article-card-${a.slug}`}
            className="card-elegant group flex flex-col"
          >
            <div className="flex items-center gap-3 text-xs">
              <span className="rounded-full bg-gold-soft px-3 py-1 font-semibold uppercase tracking-wide text-gold-dark">
                {a.category}
              </span>
              <span className="text-slate-400">{a.readingTime}</span>
            </div>
            <h2 className="mt-4 font-serif text-xl sm:text-2xl font-semibold leading-snug text-navy">
              {a.title}
            </h2>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{a.excerpt}</p>
            <div className="mt-4 flex items-center justify-between">
              <time dateTime={a.date} className="text-xs text-slate-400">
                {a.dateLabel}
              </time>
              <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-gold-dark transition-transform duration-300 group-hover:translate-x-1">
                Leggi <ArrowRight size={15} aria-hidden="true" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>

    <CtaBand />
  </>
);

export default Approfondimenti;
